<template>
	<div class="container-fluid">
		<div class="row">
			<!-- PROGRAMACIONES -->
			<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
				<div class="card">
					<div class="card-header bg-danger text-white">
						<div class="row">
							<div class="col text-left">
								<span class="fa fa-calendar mr-2"></span>
								Programaciones activas
							</div>
							<div class="col text-right">
								<button class="btn btn-dark btn-sm" @click="nueva()">
									<span class="fa fa-edit mr-2"></span>
									Nueva descarga
								</button>
							</div>
						</div>
					</div>
					<div class="table-responsive">
						<table class="table table-striped table-condensed m-0">
							<tbody>
								<tr v-for="prog in listadoProgramaciones" :key="prog.ID_programacion">
									<td style="width:100px;vertical-align:middle;text-align:center;">
										<img :src="'/src/modulos/gestion-emisoras/php/api/emisoras/ver-logo.php?logotipo=' + prog.EmisoraLogo" style="height:30px;" :title="prog.EmisoraNombre">
									</td>
									<td style="width: 30px; font-size:2em;">
										<span class="fa" :class="(prog.tipo === 'diferida') ? 'fa-clock-o' : 'fa-calendar'"></span>
									</td>
									<td>
										<b>{{prog.titulo}}</b> <i style="color:#888888;">(de {{prog.horaIni}} a {{prog.horaFin}})</i>
										<br>
										<div v-if="prog.tipo === 'diferida'">
											El próximo {{new Date(prog.diferida.fecha).toLocaleDateString()}} a las {{prog.diferida.hora}}
										</div>
										<div v-if="prog.tipo === 'periodica'">
											Todos los {{getDiasBonitos(prog.periodica.dias)}}
											desde el {{new Date(prog.periodica.fechaIni).toLocaleDateString()}}
											<span v-if="prog.periodica.fechaFin">hasta el {{new Date(prog.periodica.fechaFin).toLocaleDateString()}}</span>
											a las {{prog.periodica.hora}}
										</div>
										<div style="font-size:0.9em;opacity:0.7;">
											Creado por {{prog.usuario.nombre}} {{prog.usuario.apellidos}}
											<span v-if="usuario.ID !== prog.usuario.ID">con ámbito público</span>
										</div>
									</td>
									<td style="width:80px;text-align:center;vertical-align:middle;">
										<div v-if="usuario.ID === prog.usuario.ID">
											<button class="btn btn-sm btn-primary" @click="programacion = prog">
												<span class="fa fa-edit"></span>
											</button>
											<button class="btn btn-sm btn-danger" @click="eliminarPrograma(prog)">
												<span class="fa fa-trash"></span>
											</button>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="card-body text-center text-danger" v-if="listadoProgramaciones.length === 0">
						<span class="fa fa-info-circle" style="font-size:3em;"></span>
						<h3>No hay programaciones activas</h3>
					</div>
				</div>
			</div>

			<!-- FICHEROS PENDIENTES DE DESCARGAR -->
			<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
				<div class="card">
					<div class="card-header bg-warning">
						<span class="fa fa-copy mr-2"></span>
						Ficheros generados
					</div>
					<div class="table-responsive">
						<table class="table table-striped table-condensed m-0">
							<tbody>
								<tr v-for="fichero in listadoFicheros" :key="fichero.ID_fichero">
									<td style="width:100px;vertical-align:middle;text-align:center;">
										<img :src="'/src/modulos/gestion-emisoras/php/api/emisoras/ver-logo.php?logotipo=' + fichero.EmisoraLogo" style="height:30px;">
									</td>
									<td>
										<b>{{fichero.titulo}} - {{fichero.programacion.horaIni}} a {{fichero.programacion.horaFin}}</b>
										<br>
										<span style="color:#999999;font-style:italic;">
											Generado: {{fichero.fechaGenerado}} a las {{ fichero.horaGenerado }}
										</span>
									</td>
									<td style="width:40px;text-align:center;vertical-align:middle;">
										<button class="btn btn-sm btn-primary" @click="descargar(fichero.ID_descarga)">
											<span class="fa fa-download"></span>
										</button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<programador-copion v-if="programacion" :data="programacion" @cerrar="cierraProgramacion()"></programador-copion>
	</div>
</template>

<script>
import API from './api'
import Programador from './componentes/programador'
import { mapGetters } from 'vuex'

export default {
	components: {
		'programador-copion': Programador
	},
	data () {
		return {
			listadoFicheros: [],
			listadoProgramaciones: [],
			programacion: null,
			dias: ['', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
			refrescar: null
		}
	},

	created () {
		this.getListadoProgramaciones()
		this.getListadoDescargas()

		this.refrescar = window.setInterval(() => {
			this.getListadoProgramaciones()
			this.getListadoDescargas()
		}, 10000)
	},

	beforeDestroy () {
		window.clearInterval(this.refrescar)
	},

	computed: {
		...mapGetters({
			usuario: 'session/usuario'
		})
	},

	methods: {
		nueva () {
			this.programacion = {
				titulo: '',
				notificaEmail: true,
				fecha: null,
				horaIni: '',
				horaFin: '',
				publica: false,
				periodica: null,
				diferido: null,
				EmisoraID: null
			}
		},
		cierraProgramacion () {
			this.programacion = null
			this.getListadoProgramaciones()
		},
		getListadoProgramaciones () {
			API.getListadoProgramaciones()
				.then(res => {
					this.listadoProgramaciones = res
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		getListadoDescargas () {
			API.getListadoDescargas()
				.then(res => {
					this.listadoFicheros = res.data.descargas
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		descargar (idDescarga) {
			document.location.href = '/src/modulos/descargar-copion/php/api/descargar.php?ID_descarga=' + idDescarga
		},
		getDiasBonitos (dias) {
			dias = dias.toString()
			let d = []
			for (let i = 0; i <= 7; i++) {
				if (dias.search(i.toString()) >= 0) {
					d.push(this.dias[i])
				}
			}
			let cadena = d.join(', ', d)
			return cadena.replace(/,([^,]{1,})$/, ' y $1')
		},

		eliminarPrograma (prog) {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar programación',
				mensaje: `¿Quieres eliminar esta programación?`,
				callback: (acepta) => {
					if (acepta) {
						API.eliminarProgramacion(prog.ID_programacion)
							.then(() => {
								this.getListadoProgramaciones()
							})
							.catch(e => {
								this.$store.commit('alertas/error', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/descargar-copion/vue/app.vue